/**
 * ThinkingIndicator Component
 * Shows a shimmer animation while the AI is thinking/generating
 * Now with rotating messages to show progress
 */

import { useState, useEffect } from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Bot, Brain } from "lucide-react";
import { cn } from "@/lib/utils";
import ShinyText from "@/components/ShinyText";

interface ThinkingIndicatorProps {
  className?: string;
}

const thinkingMessages = [
  { icon: Brain, text: "Pensando...", delay: 0 },
  // { icon: Database, text: "Conectando con tus datos", delay: 3000 },
  // { icon: Search, text: "Buscando información relevante", delay: 6000 },
  // { icon: FileText, text: "Preparando la respuesta", delay: 9000 },
];

export const ThinkingIndicator = ({ className }: ThinkingIndicatorProps) => {
  const [messageIndex, setMessageIndex] = useState(0);

  // Rotate through thinking messages every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % thinkingMessages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const currentMessage = thinkingMessages[messageIndex];
  const MessageIcon = currentMessage.icon;

  return (
    <div
      className={cn(
        "flex gap-4 py-4 px-6 w-full justify-start animate-in fade-in-50 duration-300",
        className
      )}
    >
      {/* Avatar */}
      <div className="flex-shrink-0">
        <Avatar className="h-8 w-8">
          <AvatarFallback className="bg-gradient text-white">
            <Bot className="h-4 w-4" />
          </AvatarFallback>
        </Avatar>
      </div>

      {/* Thinking Bubble */}
      <div className="max-w-[75%] flex flex-col items-start">
        {/* Header */}
        <div className="flex items-center gap-2 px-1 mb-1">
          <span className="font-semibold text-sm">Trud Agentic</span>
        </div>

        {/* Bubble with rotating message */}
        <div className="rounded-3xl rounded-tl-sm px-5 py-3 bg-background-100 border border-border shadow-sm min-w-[200px]">
          <div className="flex items-center gap-2.5">
            <MessageIcon className="h-3.5 w-3.5 text-gradient shrink-0 animate-pulse" />
            <ShinyText speed={3} className="text-sm font-normal">
              {currentMessage.text}
            </ShinyText>
          </div>
        </div>
      </div>
    </div>
  );
};
